import { render, staticRenderFns } from "./kouluttaja-details.vue?vue&type=template&id=15676dd8&"
import script from "./kouluttaja-details.vue?vue&type=script&lang=ts&"
export * from "./kouluttaja-details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports